import styled from "styled-components"

export default styled.div.attrs({ className: "row" })`
  display: flex;
`
